// extracted by mini-css-extract-plugin
export default {"content":"page_content__BnK++","ceocard":"page_ceocard__V-LmH","card":"page_card__r02ZB","img":"page_img__+TK+d","label":"page_label__5QP3G","desc":"page_desc__KTm37"};